import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import logger from '../../../utils/logger';

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these use matchers!
    if (isRejectedWithValue(action)) {
        const { method, url } = action.meta.baseQueryMeta.request;
        const errorMessage = action.error.message;
        const message = `${method} - ${url} : ${errorMessage}`;
        logger.error(message);
    }
    return next(action);
};
